import type { RegionATC } from '@/types/domain/core';
import { coreRequestService } from '@/api/core';

export const regionAtcGet = () => coreRequestService<RegionATC[]>({
    url: '/region/atc',
    method: 'GET'
});
